import ApiService from '../../../shared/services/ApiService';

export default {

    getBillingInfo() {
        return ApiService.get('billing-information');
    },

    subscribe(data) {
        return ApiService.post('subscribe', data);
    },

    pendingInvites(data) {
        return ApiService.post('pending-invites', data);
    },

    getTaxAmountForSubscription(data) {
        return ApiService.get(`tax-calculator-subscription?country=${data.country}&state=${data.state}&zip=${data.zip}&city=
            ${data.city}&address=${data.address}&price_plan=${data.price_plan}&quantity=${data.quantity}`);
    },

    getTaxAmountForPurchaseSeats(amount, quantity) {
        return ApiService.get(`tax-calculator-purchase-seats/${amount}/${quantity}`);
    }
}